module.exports = __webpack_public_path__ + "fonts/flaticon.99da30cb.woff2";